/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as appointAction from '../state/action'
import * as appAction from '../../App/state/action'
import * as getMessage from '../../../shared/containers/IntlProvider/state/actions';
import * as fileUploadAction from '../../FileUploadInfo/state/action'
import BasePage from '../../../shared/BasePage';
import paths from '../../../config/path';
import history from '../../../utils/history';
import { apiMap, settings } from '../../../config/constants';

import CheckList from '../components/CheckList';
import SubmitTitle from '../components/SubmitTitle';
import ReviewDoc from '../components/ReviewDoc';
import EditApplication from '../components/EditApplication';
import ReferenceCodeInput from '../components/ReferenceCodeInput';
import '../components/style/Appointment.css';
import {
    findQuestionById,
    aoformQuestionShouldDisplay,
    documentCheckListQuestionShouldDisplay
} from '../../../utils/AOFormUtils';
import { HSBCError } from '../../../apiClient';
import { taggingHandler, trackEvent, setTitle } from '../../../utils';
import UtagData from "../../../config/tagging";

class Appointment extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            editedApplication: false,
            disabledReferCodeBtn: true,
            pdfList: [],
            downLoadPDFUrl: "",
            disabledEditBtn: true
        };
        [
            "handleSubmitReferCode",
            "handleReferCode",
            "handleDownLoadPDF"
        ].forEach((fn) => this[fn] = this[fn].bind(this));
    }

    componentWillUnmount = () => {
        this.timer && clearInterval(this.timer);
    }

    componentDidMount = () => {
        this.retrvBussinessApi();
        this.loadContentMessage();
    }

    loadContentMessage = () => {
        this.props.getMessage('appointment', 'i18n_appoint');
    }
    getApplicationInfo = () => {
        this.props.retrvApp();
    }
    showCheckList = (isShow) => {
        this.setState({ showCheckList: isShow });
    }

    handleEdit = () => {
        this.props.clearError();
        this.setState({ editedApplication: true });
        this.handleTag('appointment2');
    }
    handleBackBtn = () => {
        this.props.clearError();
        this.setState({ editedApplication: false });
        this.handleTag('appointment');
    }
    handleTag = (tag) => {
        taggingHandler(UtagData[tag])
    }
    handleReferCode = (e) => {
        const reg = /^[0-9a-z]{8,8}$/;
        const val = this.referenceCode.value;
        if(reg.test(val)){
            this.setState({ disabledReferCodeBtn: false });
        }else{
            this.setState({ disabledReferCodeBtn: true });
        }
    }
    handleSubmitReferCode = () => {
        trackEvent('appointment');
        this.props.unfrozenApp(this.props.applicationInfo,this.referenceCode.value, () => {
            history.push(paths.dashboard.path);
        });
    }
    handleDownLoadPDF = (iccmFileNetId) => {
        this.props.downloadFlie(iccmFileNetId)
            .then(result => {
                const downloadKey = result.respBody.key;
                const filePath = settings.hostnameDownloadFlie + apiMap.getDownloadFile(`1/${downloadKey}`).api;
                window.open(filePath);
            });
    }
    retrvBussinessApi = () => {
        this.props.retrvBussiness()
            .then(resp => {
            if(resp && resp.respBody){
                let isLoading = this.getPDFList(resp.respBody);
                if(isLoading){
                    this.timer = setInterval(function () {
                        if(isLoading){
                            this.props.retrvBussiness()
                            .then(resp => {
                                isLoading = this.getPDFList(resp.respBody);
                                if(!isLoading){
                                    this.setState({ disabledEditBtn: false });
                                    clearInterval(this.timer);
                                }
                            })
                            .catch( error => {
                                clearInterval(this.timer);
                            })
                        }
                    }.bind(this), 20000);
                }else{
                    this.setState({ disabledEditBtn: false });
                }
            }
        })
        
    }
    getPDFList = (businessInfo) => {
        let pdfArr = [], isLoading = false;
        if(businessInfo && businessInfo.attachments){
            const attachments = businessInfo.attachments;
            Object.keys(attachments).forEach(item => {
                if(item !== 'AOForm'){
                    attachments[item].dataKay = item;
                    attachments[item].status = this.getPDFStatus(attachments[item].status);
                    pdfArr.push(attachments[item]);
                }
            });
            this.setState({ pdfList: pdfArr });
            isLoading = this.getLoadingStatus(pdfArr);
        }else{
            const error = new HSBCError("","");
            this.props.handleError(error);
            this.timer && clearInterval(this.timer);
            isLoading = false;
        }
        return isLoading;
    }
    getLoadingStatus = (pdfArr) => {
        let isLoading = false;
        for(let i=0; i<pdfArr.length; i++){
            // if (pdfArr[i].status === "INIT" || pdfArr[i].status === "GENERATED") {
            //     isLoading = true;
            // }
            if(pdfArr[i].status === "SAVED"){
                continue;
            }else if(pdfArr[i].status === "GENERATED"){
                isLoading = true;
            }else if(pdfArr[i].status === "GENERATE_FAILED"){
                // const error = new HSBCError("RBB00003","");
                // this.props.handleError(error);
                continue;
            }
        }
        return isLoading;
    }
    formatPDFList = (PDFNameList) => {
        let pdfArr = [];
        this.state.pdfList.forEach((item, index) => {
            item.name = PDFNameList[item.dataKay];
            pdfArr.push(item);
        });
        return pdfArr;
    }
    getPDFStatus = (status) => {
        if( status === "INIT" ){
            status = "GENERATED";
        } else if( status === "SAVED_FAILED" ) {
            status = "GENERATE_FAILED"
        }
        return status;
    }
    getFileList = () => {
        let fileList = [], fileName = {}, pdfArr = [];
        if(this.props && this.props.applicationInfo && this.props.businessInfo && this.props.i18n_appoint){
            pdfArr = this.formatPDFList(this.props.i18n_appoint.PDFNameList);
            const applicationInfo = this.props.applicationInfo;
            const {questionStatus} = this.props.businessInfo;
            const checkListObj = findQuestionById(applicationInfo, "S005");
            const docCheckListObj = findQuestionById(applicationInfo, "S004");

            docCheckListObj.questions.forEach((question) => {
                questionStatus && Object.keys(questionStatus).forEach( indicate => {
                    if(documentCheckListQuestionShouldDisplay(applicationInfo, question) && indicate === question.questionIndicator && questionStatus[indicate] === "2"){
                        fileName = {
                            "name" : this.getLabelTxt(question.questionLocales),
                            "dataKay" : question.questionIndicator
                        };
                        fileList.push(fileName);
                    }
                });
            });
            checkListObj.questions.forEach((question) => {
                if (aoformQuestionShouldDisplay(applicationInfo, question)){
                    fileName = {
                        "name" : this.getLabelTxt(question.questionLocales),
                        "dataKay" : question.questionIndicator
                    };
                    fileList.push(fileName);
                }
            });
        }

        return {fileList,pdfArr};
    }
    getLabelTxt = (questionLocales) => {
        const { selectedLanguage } = this.props;
        let locale = "";
        questionLocales.some((qLocale) => {
            if (qLocale.locale === selectedLanguage.substring(0, 2)) {
                locale = qLocale.detail;
                return true;
            }
            return false;
        })
        return locale;
    }
    render() {
        const { i18n_appoint, isDisplayInputErr, inputErrMsg, applicationInfo, pageTitle } = this.props;
        let { editedApplication, disabledReferCodeBtn, disabledEditBtn } = this.state;
        const {fileList,pdfArr} = this.getFileList();
        
        if (i18n_appoint && applicationInfo && pageTitle) {
            if (editedApplication) {
              setTitle( i18n_appoint.referenceCodeInput.editAppTitle.title + pageTitle);
            } else {
              setTitle( i18n_appoint.submitTitle.title + pageTitle);
            }
        }
        if (applicationInfo && (applicationInfo.status === 2 || applicationInfo.status === 4)) {
            disabledEditBtn = false;
        }
        return i18n_appoint && applicationInfo ? (
            <div className="dynamic-form apponitment-container container" >
                <div className="apponitment-content">
                    { editedApplication ?
                        (<ReferenceCodeInput
                            i18n={i18n_appoint.referenceCodeInput}
                            backAction={this.handleBackBtn}
                            submitRefeCodeAction={this.handleSubmitReferCode}
                            referenceCode={input => this.referenceCode = input}
                            referCodeAction={this.handleReferCode}
                            disabled={isDisplayInputErr ? true : disabledReferCodeBtn}
                            isDisplayErr={isDisplayInputErr}
                            inputErrMsg={inputErrMsg}
                            />)
                    :   (<div>
                            <SubmitTitle i18n={i18n_appoint.submitTitle} isShowIcon={true}/>
                            <ReviewDoc
                                i18n={i18n_appoint.reviewDoc}
                                updateFileAction={this.handleDownLoadPDF}
                                pdfList={pdfArr}
                                applicationInfo={applicationInfo}
                            />
                            <CheckList
                                i18n={i18n_appoint.checkList}
                                fileList={fileList} />
                            <EditApplication
                                i18n={i18n_appoint.editApplication}
                                editBtnAction={this.handleEdit}
                                disabledEditBtn={disabledEditBtn}/>
                        </div> )
                    }
                </div>
            </div>
        ) : null
    }
    }
const mapStateToProps = (state) => {
    const errMsgMapping = state.app.i18n.errorMessage;
    return {
        selectedLanguage: state.app.selectedLanguage,
        applicationInfo: state.app.applicationInfo,
        businessInfo: state.app.businessInfo,
        i18n_appoint: state.intl.messages.i18n_appoint,
        isDisplayInputErr: state.app.isDisplayInputErr,
        inputErrMsg: state.app.inputErrCode ? errMsgMapping[state.app.inputErrCode] : null,
        pageTitle: state.app.i18n.pageTitle
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(getMessage, dispatch),
        ...bindActionCreators(appointAction, dispatch),
        ...bindActionCreators(appAction, dispatch),
        ...bindActionCreators(fileUploadAction, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Appointment);


// WEBPACK FOOTER //
// ./src/views/Appointment/container/Appointment.js